import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import MoreIcon from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';
import { compose, setDisplayName } from 'recompose';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { isMobile } from 'helpers/detect-mobile';
import { withTracker } from 'components/Tracker';
import HomeSidebar from './HomeSidebar';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing.unit,
  },
  toolbar: {
    minHeight: 70,
    alignItems: 'center',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    justifyContent: 'center',
  },
  title: {
    flexGrow: 1,
    alignSelf: 'flex-end',
  },
  btn: {
    color: '#727272',
  },
});

class TopNav extends Component {
  static propTypes = {
    classes: PropTypes.shape({}),
    history: PropTypes.shape({}).isRequired,
    formatMessage: PropTypes.func.isRequired,
  };

  static contextTypes = {
    brands: PropTypes.shape({}),
  };

  static defaultProps = {}

  state = {
    openSidebar: false
  }

  toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    this.setState({ openSidebar: open });
  };

  render() {
    const { formatMessage, classes } = this.props;
    const { openSidebar } = this.state;
    const { brands } = this.context;

    return (
      <div className={`${classes.root} top-nav`}>
        <AppBar position="static" style={{ backgroundColor: '#f5f5f5', color: '#727272' }}>
          <Toolbar className={classes.toolbar}>
            {isMobile ?
              (
                <div className="d-flex" style={{ width: '100%' }}>
                  <IconButton
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.toggleDrawer(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                </div>
              )
              : (
                <div className="nav" style={{ alignItems: 'center' }}>
                  <div className="nav-logo">
                    <Link to="/">
                      <img
                        alt="sun"
                        className="logo"
                        src={brands.logoUrl}
                      />
                    </Link>

                  </div>
                  <div className="d-flex nav-menu">
                    <div className="nav-pull-right font-nav-item">
                      <div className="nav-title">
                        {formatMessage('FRESHr PRO go to >')}
                      </div>
                      <div className="nav-item">
                        <Link to="/features?category=farm">
                          <Button className={classes.btn}> {formatMessage('Farms')}</Button>
                        </Link>
                      </div>
                      <div className="nav-item">
                        <Link to="/features?category=restaurant">
                          <Button className={classes.btn}> {formatMessage('Restaurants/Grocers')}</Button>
                        </Link>
                      </div>
                      <div className="nav-item">
                        <Link to="/features?category=distributor">
                          <Button className={classes.btn}>{formatMessage('Distributors')}</Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Toolbar>
        </AppBar>
        <HomeSidebar
          sidebarOpen={openSidebar}
          toggleDrawer={this.toggleDrawer}
        />
      </div>
    );
  }
}


/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  login: payload => dispatch(login(payload)),
});



export default compose(
  setDisplayName('TopNav'),
  connect(
    mapDispatchToProps,
  ),
  injectIntl,
  immutableToJS,
  withStyles(styles),
  withTracker,
)(TopNav);
